
<div class="sidebar" [ngStyle]="customStyles">
    <ng-content></ng-content>
</div>
